module.exports = __webpack_public_path__ + "img/logo-ministerio-economia-realizacao.d115bf07.png";